import { getId } from '@/store/utils'
import { normalizeHexColor } from '../color'
import type { XmlImportColorItem } from '../types'
import { getChildElements, getFirstChildElement } from './dom'

const FALSY_ATTRIBUTE_VALUES = new Set(['false', '0', 'no', 'off'])

const parseShowInLegend = (colorElement: Element): boolean | undefined => {
  const value = colorElement.getAttribute('show_in_legend')

  if (value === null) {
    return undefined
  }

  return !FALSY_ATTRIBUTE_VALUES.has(value.trim().toLowerCase())
}

const parseColorElement = (
  colorElement: Element
): XmlImportColorItem | null => {
  const hexCode = normalizeHexColor(
    colorElement.getAttribute('hex') || colorElement.getAttribute('color') || ''
  )

  if (!hexCode) {
    return null
  }

  const title = colorElement.textContent?.trim() || ''

  // Названный цвет — это подпись категории, ей место в легенде; без имени
  // объявление задаёт только hex, и в легенду он не лезет.
  const showInLegend = parseShowInLegend(colorElement) ?? Boolean(title)

  return {
    id: getId(),
    hexCode,
    declared: true,
    showInLegend,
    ...(title ? { title } : {}),
  }
}

const parseProjectColorsElement = (
  colorsElement: Element | null
): XmlImportColorItem[] => {
  if (!colorsElement) {
    return []
  }

  const colorsByHex = new Map<string, XmlImportColorItem>()

  getChildElements(colorsElement, 'color').forEach((colorElement) => {
    const color = parseColorElement(colorElement)

    if (color && !colorsByHex.has(color.hexCode)) {
      colorsByHex.set(color.hexCode, color)
    }
  })

  return Array.from(colorsByHex.values())
}

export const parseProjectColors = (
  rootElement: Element
): XmlImportColorItem[] =>
  parseProjectColorsElement(getFirstChildElement(rootElement, ['colors']))
